import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--extranarrow" }
const _hoisted_2 = {
  key: 0,
  class: "_mt-6",
  "data-qa": "user-profile:Projects"
}
const _hoisted_3 = { class: "gfu-hd gfu-hd--h1" }
const _hoisted_4 = { class: "gfu-link-underline__content" }
const _hoisted_5 = {
  key: 0,
  class: "gfu-card-list gfu-scrollable _-mb-3 _mt-2"
}
const _hoisted_6 = {
  class: "_mt-3",
  "data-qa": "user-profile-projects:Title"
}
const _hoisted_7 = {
  key: 1,
  class: "_mt-6",
  "data-qa": "user-profile:Followers"
}
const _hoisted_8 = { class: "gfu-hd gfu-hd--h1" }
const _hoisted_9 = { class: "gfu-link-underline__content" }
const _hoisted_10 = {
  key: 0,
  class: "gfu-card-list gfu-scrollable _-mb-3 _mt-2"
}
const _hoisted_11 = ["data-qa"]
const _hoisted_12 = { class: "_mt-3" }
const _hoisted_13 = {
  key: 2,
  class: "_mt-6",
  "data-qa": "user-profile:Following"
}
const _hoisted_14 = { class: "gfu-hd gfu-hd--h1" }
const _hoisted_15 = { class: "gfu-link-underline__content" }
const _hoisted_16 = {
  key: 0,
  class: "gfu-card-list gfu-scrollable _-mb-3 _mt-2"
}
const _hoisted_17 = ["data-qa"]
const _hoisted_18 = { class: "_mt-3" }
const _hoisted_19 = {
  key: 3,
  class: "_mt-6",
  "data-qa": "user-profile:Comments"
}
const _hoisted_20 = { class: "gfu-hd gfu-hd--h1" }
const _hoisted_21 = { class: "gfu-link-underline__content" }
const _hoisted_22 = { class: "_mt-3" }
const _hoisted_23 = { class: "_mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_project_card = _resolveComponent("project-card")
  const _component_base_button = _resolveComponent("base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_user_profile_card = _resolveComponent("user-profile-card")
  const _component_comment_item_preview = _resolveComponent("comment-item-preview")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.isProjectsVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.Resources.Profile.SectionProjectsHeader), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString(_ctx.Resources.Profile.SectionProjectsParagraph), 1 /* TEXT */),
          _createVNode(_component_router_link, {
            to: { name: 'user-profile-projects' },
            class: "_tc--accent gfu-link-underline"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Resources.Profile.SectionViewAllAction), 1 /* TEXT */),
              _createVNode(_component_base_icon, {
                name: "angle-right",
                size: "sm"
              })
            ]),
            _: 1 /* STABLE */
          }),
          ($options.hasProjects)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.projectsItemsSlicedWithUrlRef, (project) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: project.projectID,
                    class: "gfu-card-list__item gfu-5of6 gfu-2of5--m gfu-1of3--l gfu-1of3--xl"
                  }, [
                    _createVNode(_component_project_card, _mergeProps({ ref_for: true }, project, { "show-labels": true }), null, 16 /* FULL_PROPS */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createBlock(_component_box, {
                key: 1,
                class: "_mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_empty_state, {
                    title: _ctx.Resources.Profile.EmptyStateProjectsTitle,
                    "data-qa": "user-profile:EmptyState"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Resources.Profile.EmptyStateProjectParagraphOwnProfile), 1 /* TEXT */),
                      _createVNode(_component_base_button, {
                        tag: "a",
                        href: $options.searchUrl,
                        class: "_mt-3",
                        theme: "accent",
                        "data-qa": "user-profile-projects:Explore"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Resources.Profile.EmptyStateProjectsExploreAction), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["href"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["title"])
                ]),
                _: 1 /* STABLE */
              }))
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isFollowersVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.Resources.Profile.SectionFollowersHeader), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Profile.SectionFollowersParagraph, $props.nickname)), 1 /* TEXT */),
          _createVNode(_component_router_link, {
            to: { name: 'user-profile-followers' },
            class: "_tc--accent gfu-link-underline"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Resources.Profile.SectionViewAllAction), 1 /* TEXT */),
              _createVNode(_component_base_icon, {
                name: "angle-right",
                size: "sm"
              })
            ]),
            _: 1 /* STABLE */
          }),
          ($options.hasFollowers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.followersItems, (follower) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: follower.urlName,
                    class: "gfu-card-list__item gfu-5of6 gfu-2of5--m gfu-1of3--l gfu-1of3--xl",
                    "data-qa": `user-card-urlname:${follower.urlName}`
                  }, [
                    _createVNode(_component_user_profile_card, _mergeProps({ ref_for: true }, follower), null, 16 /* FULL_PROPS */)
                  ], 8 /* PROPS */, _hoisted_11))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createBlock(_component_box, {
                key: 1,
                class: "_mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_empty_state, {
                    title: _ctx.Resources.Profile.EmptyStateFollowersTitle,
                    "data-qa": "user-profile:EmptyState"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.Resources.Profile.EmptyStateFollowersParagraph), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["title"])
                ]),
                _: 1 /* STABLE */
              }))
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isFollowedVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.Resources.Profile.SectionFollowingHeader), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Profile.SectionFollowingParagraph, $props.nickname)), 1 /* TEXT */),
          _createVNode(_component_router_link, {
            to: { name: 'user-profile-following' },
            class: "_tc--accent gfu-link-underline"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.Resources.Profile.SectionViewAllAction), 1 /* TEXT */),
              _createVNode(_component_base_icon, {
                name: "angle-right",
                size: "sm"
              })
            ]),
            _: 1 /* STABLE */
          }),
          ($options.hasFollowed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.followingItems, (follower) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: follower.urlName,
                    class: "gfu-card-list__item gfu-5of6 gfu-2of5--m gfu-1of3--l gfu-1of3--xl",
                    "data-qa": `user-card-urlname:${follower.urlName}`
                  }, [
                    _createVNode(_component_user_profile_card, _mergeProps({ ref_for: true }, follower), null, 16 /* FULL_PROPS */)
                  ], 8 /* PROPS */, _hoisted_17))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createBlock(_component_box, {
                key: 1,
                class: "_mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_empty_state, {
                    title: _ctx.Resources.Profile.EmptyStateFollowingTitle,
                    "data-qa": "user-profile:EmptyState"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.Resources.Profile.EmptyStateFollowingParagraph), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["title"])
                ]),
                _: 1 /* STABLE */
              }))
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isCommentsVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.Resources.Profile.SectionCommentsHeader), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Profile.SectionCommentsParagraph, $props.nickname)), 1 /* TEXT */),
          _createVNode(_component_router_link, {
            to: { name: 'user-profile-comments' },
            class: "_tc--accent gfu-link-underline"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.Resources.Profile.SectionViewAllAction), 1 /* TEXT */),
              _createVNode(_component_base_icon, {
                name: "angle-right",
                size: "sm"
              })
            ]),
            _: 1 /* STABLE */
          }),
          ($options.hasComments)
            ? (_openBlock(), _createBlock(_component_box, {
                key: 0,
                class: "_mt-5"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.commentsItemsSliced, (item) => {
                    return (_openBlock(), _createBlock(_component_comment_item_preview, _mergeProps({
                      key: item.commentID
                    }, { ref_for: true }, item, {
                      class: "_mb-4",
                      nickname: $props.nickname,
                      "avatar-url": $props.avatarUrl,
                      "user-url-name": $props.userUrlName,
                      "user-id": $props.userID,
                      "data-qa": `project-comment-ID:${item.commentID}`
                    }), null, 16 /* FULL_PROPS */, ["nickname", "avatar-url", "user-url-name", "user-id", "data-qa"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }))
            : (_openBlock(), _createBlock(_component_box, {
                key: 1,
                class: "_mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_empty_state, {
                    title: _ctx.Resources.Profile.EmptyStateCommentsTitle,
                    "data-qa": "user-profile:EmptyState"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.Resources.Profile.EmptyStateCommentsParagraphOwnProfile), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["title"])
                ]),
                _: 1 /* STABLE */
              }))
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isGuestEmptyStateVisible)
      ? (_openBlock(), _createBlock(_component_box, {
          key: 4,
          class: "_mt-6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_empty_state, {
              title: _ctx.Resources.Profile.EmptyStateProfileViewTitle,
              "data-qa": "user-profile:EmptyState"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Profile.EmptyStateProfileViewParagraph, $props.nickname)), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}